module.exports = __webpack_public_path__ + "static/media/1003021.3c161851.jpg";